import { render, staticRenderFns } from "./RawMaterialsClosed.vue?vue&type=template&id=0de85154&"
import script from "./RawMaterialsClosed.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports